// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"Select__pc_only___2lk5x","sp_only":"Select__sp_only___2wNdF","select":"Select__select___Tq_31"};